// src-lit/components/product/price.logic.ts
/**
 * 価格計算系ロジック（純粋関数）
 *
 * SSR側の calcDiscountRate.liquid と同等のロジックをCSR側でも提供する。
 * これは設計上意図された「別責務」の重複:
 *   - SSR: 初期表示時の割引率計算
 *   - CSR: ユーザー操作後のリアルタイム計算
 */

/**
 * 割引率を計算する
 *
 * @param price - 販売価格（分単位: 100 = ¥100）
 * @param compareAtPrice - 定価（分単位: 100 = ¥100）
 * @returns 割引率（0〜99 の整数）。定価が無い/販売価格以下の場合は 0。
 */
export function calculateDiscountRate(price: number, compareAtPrice: number): number {
  if (compareAtPrice <= 0 || compareAtPrice <= price) return 0;
  return Math.floor(((compareAtPrice - price) / compareAtPrice) * 100);
}

/**
 * セール中かどうかを判定する
 *
 * @param price - 販売価格
 * @param compareAtPrice - 定価
 * @returns 定価より安い場合 true
 */
export function isOnSale(price: number, compareAtPrice: number): boolean {
  return compareAtPrice > 0 && price < compareAtPrice;
}
